import React          from 'react';
import classnames     from 'classnames';
import connectField   from 'uniforms/connectField';
import filterDOMProps from 'uniforms/filterDOMProps';
import joinName       from 'uniforms/joinName';
import {Children}     from 'react';

import ListItemField from './ListItemField';
import ListAddField from './ListAddField';

import {
  Col,
} from '@sketchpixy/rubix';

const CustomListField = ({
    addIcon,
    children,
    className,
    error,
    errorMessage,
    initialCount,
    itemProps,
    label,
    name,
    removeIcon,
    showInlineError,
    value,
    ...props
}) =>
    <div
        className={classnames('panel panel-default custom-list-field', {'panel-danger': error}, className)}
        {...filterDOMProps(props)}
    >
        <div className="panel-body">
            <Col sm={12}>
                {label && (

                    <div className={classnames('panel-heading', {'has-error': error})}>
                        <Col sm={12}>
                            <label className="control-label">
                                {label}&nbsp; : &nbsp;&nbsp;&nbsp;&nbsp;<ListAddField name={`${name}.$`} initialCount={initialCount} addIcon={addIcon} />
                            </label>
                        </Col>

                        {!!(errorMessage && showInlineError) && (
                            <span className="help-block">
                                {errorMessage}
                            </span>
                        )}
                    <br/><br/>
                    </div>
                )}
            </Col>

            <Col sm={12}>
                {children ? (
                    value.map((item, index) =>
                          Children.map(children, child =>
                               React.cloneElement(child, {
                                   key: index,
                                   label: null,
                                   name: joinName(name, child.props.name && child.props.name.replace('$', index)),
                                   removeIcon
                               })
                          )
                     )
                ) : (
                    value.map((item, index) =>
                        <ListItemField
                            key={index}
                            label={null}
                            name={joinName(name, index)}
                            removeIcon={removeIcon}
                            {...itemProps}
                        />
                    )
                )}
            </Col>
        </div>
    </div>;


export default connectField(CustomListField, {includeInChain: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/customListField.js
 **/